import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import GuestModal from "./components/GuestModal";
import Home from "./pages/Home";
import SorteosExclusivos from "./pages/SorteosExclusivos";
import AccionesCaza from "./pages/AccionesCaza";
import Fincas from "./pages/Fincas";
import Modalidades from "./pages/Modalidades";
import HomologaTuTrofeo from "./pages/HomologaTuTrofeo";
import VideoClub from "./pages/VideoClub";
import Tienda from "./pages/Tienda";
import ProductoDetalle from "./pages/ProductoDetalle";
import Checkout from "./pages/Checkout";
import HazteSocio from "./pages/HazteSocio";
import Login from "./pages/Login";
import AreaSocio from "./pages/AreaSocio";
import Admin from "./pages/Admin";
import GestionTienda from "./pages/GestionTienda";
import PaymentResult from "./pages/PaymentResult";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Protected({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
        <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App bg-carbon min-h-screen flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollTop />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sorteos-exclusivos" element={<SorteosExclusivos />} />
                <Route path="/acciones-de-caza" element={<AccionesCaza />} />
                <Route path="/fincas" element={<Fincas />} />
                <Route path="/modalidades" element={<Modalidades />} />
                <Route path="/homologa-tu-trofeo" element={<HomologaTuTrofeo />} />
                <Route path="/video-club" element={<VideoClub />} />
                <Route path="/tienda" element={<Tienda />} />
                <Route path="/tienda/:id" element={<ProductoDetalle />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/hazte-socio" element={<HazteSocio />} />
                <Route path="/login" element={<Login />} />
                <Route path="/area-socio" element={<Protected><AreaSocio /></Protected>} />
                <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
                <Route path="/gestion-tienda" element={<Protected admin><GestionTienda /></Protected>} />
                <Route path="/pago/resultado" element={<PaymentResult />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <GuestModal />
            <WhatsAppButton />
            <Toaster position="top-center" richColors theme="dark" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
